module.exports = __webpack_public_path__ + "static/stars-fb59029fb5ff57b608f62cde3c834998.svg";